import {
  WORKGROUP_LOADING,
  GET_WORKGROUP,
  GET_WORKGROUP_SUCCESS,
  GET_WORKGROUP_FAIL,
  ADD_WORKGROUP_SUCCESS,
  ADD_WORKGROUP_FAIL,
  DELETE_WORKGROUP_SUCCESS,
  DELETE_WORKGROUP_FAIL,
  UPDATE_WORKGROUP_SUCCESS,
  UPDATE_WORKGROUP_FAIL,
  WORKGROUP_RESET
} from "./actionType";

const INIT_STATE = {
  workGroups: [],
  error: {},
};

const WorkGroup = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_WORKGROUP_SUCCESS:
      switch (action.payload.actionType) {
        case GET_WORKGROUP:
          return {
            ...state,
            workGroups: action.payload.data,
            isWorkGroupCreated: false,
            isWorkGroupSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_WORKGROUP_FAIL:
      switch (action.payload.actionType) {
        case GET_WORKGROUP_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isWorkGroupCreated: false,
            isWorkGroupSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_WORKGROUP: {
      return {
        ...state,
        isWorkGroupCreated: false,
        loading: true,
      };
    }

    case WORKGROUP_LOADING: {
      return {
        ...state,
        isWorkGroupCreated: false,
        loading: true,
      };
    }

    case ADD_WORKGROUP_SUCCESS:
      return {
        ...state,
        isWorkGroupCreated: true,
        loading: false,
        workGroups: [action.payload.data, ...state.workGroups],
      };

    case ADD_WORKGROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_WORKGROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        workGroups: state.workGroups.filter(
          workGroup => workGroup.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_WORKGROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_WORKGROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        workGroups: state.workGroups.map(workGroup =>
          workGroup.id.toString() === action.payload.data.id.toString() ? { ...workGroup, ...action.payload.data } : workGroup
        ),
      };

    case UPDATE_WORKGROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case WORKGROUP_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default WorkGroup;